import type { CatalogLoadMoreTranslations } from "./pl";

export const en: CatalogLoadMoreTranslations = {
  loadMore: "Load more",
  loading: "Loading...",
  shown: (shown: number, total: number) => `Showing ${shown} of ${total}`,
};
